import EmployeesRepositoryImpl from './EmployeesRepositoryImpl';
import { fetcherAmplify, fetcherAxios } from 'src/business/Libraries/Fetcher';

const employeesRepositoryImpl = new EmployeesRepositoryImpl(fetcherAmplify);

export { employeesRepositoryImpl };
